/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Undo_RefusedInputs */

const en_undo_refused = /** @type {(inputs: Undo_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not undone: someone changed this in the meantime.`)
};

/**
* | output |
* | --- |
* | "Not undone: someone changed this in the meantime." |
*
* @param {Undo_RefusedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const undo_refused = /** @type {((inputs?: Undo_RefusedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Undo_RefusedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_undo_refused(inputs)
});